import {userStore} from "~/store/userStore";
import {navigateTo} from "#app";

export default defineNuxtRouteMiddleware(async (to, from) => {
    // Login state is persisted in localStorage, so it only exists on the client. Checking during
    // SSR would see a logged-out user and bounce every direct page load to /aphelia.
    if (import.meta.server) return;

    const useUserStore = userStore();
    const loggedInUser = useUserStore.getLoggedInUser;

    // Must be logged in
    if (!loggedInUser?.id) {
        return navigateTo('/aphelia', {replace: true});
    }

    // Must be super admin
    if (!useUserStore.getIsSuperAdmin) {
        return navigateTo('/unauthorized', {replace: true});
    }
})
